var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIllLSuccessGreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--success-50, #279349)",
  d: "M28.5 30c0-11.598 9.402-21 21-21s21 9.402 21 21-9.402 21-21 21-21-9.402-21-21"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#ill-l-success-green_svg__a)",
  d: "M8.5 43c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.7,
  d: "M44.367 34.569a1.8 1.8 0 0 1 2.625 0l1.965 2.055a2.006 2.006 0 0 1 0 2.746L37.482 51.375l-1.965 2.057a1.794 1.794 0 0 1-2.624 0l-8.85-9.26a2.006 2.006 0 0 1 0-2.745l1.966-2.057a1.8 1.8 0 0 1 2.624 0l4.26 4.458a1.797 1.797 0 0 0 2.623 0z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ill-l-success-green_svg__a",
  x1: 8.5,
  x2: 64.5,
  y1: 71,
  y2: 15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--success-10, #B7F6B3)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--success-50, #279349)"
})))));
export default SvgIllLSuccessGreen;